import * as actionTypes from "./actionTypes";

export const purchaseTool = (upgradeId: number, params: any) => ({
  type: actionTypes.PURCHASE_TOOL,
  upgradeId,
  params
});

export const updateCredits = (credits: number) => ({
  type: actionTypes.UPDATE_CREDITS,
  credits
});
